import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Link } from '@design-system/link';
export const ContentListLinkWrapper = (_a) => {
    var { LinkComponent = Link, ariaLabel, children, font, onClick, path, tabIndex, withLink = true } = _a, props = __rest(_a, ["LinkComponent", "ariaLabel", "children", "font", "onClick", "path", "tabIndex", "withLink"]);
    const commonProps = Object.assign({ width: '100%' }, props);
    const commonBoxProps = Object.assign(Object.assign({}, commonProps), { font });
    const renderClickableBox = () => (_jsx(CursorPointerWrapper, Object.assign({ onClick: onClick }, commonBoxProps, { children: children })));
    const renderStaticBox = () => _jsx(Box, Object.assign({}, commonBoxProps, { children: children }));
    if (!withLink) {
        return onClick ? renderClickableBox() : renderStaticBox();
    }
    if (path) {
        return (_jsx(LinkComponent, Object.assign({ "aria-label": ariaLabel, font: font, onClick: onClick, styledOnlyOnHover: true, tabIndex: tabIndex, to: path }, commonProps, { children: children })));
    }
    return onClick ? renderClickableBox() : renderStaticBox();
};
const CursorPointerWrapper = styled(Box) `
  cursor: pointer;
  width: 100%;
`;
//# sourceMappingURL=ContentListLinkWrapper.js.map